import React, {useEffect, useState} from "react";


import {useHistory, useParams} from "react-router-dom";
import {LinkIconButton} from "../../../components/button/LinkIconButton";
import CustomContainer from "../../../components/CustomContainer";
import {FormatHeader} from "../../format/FormatHeader";
import { useModels } from "../../../helpers/models";
import {Actions} from "../../../../client/Actions";
import CommonManagementTable from "./CommonManagementTable";
import Loader from "../../../components/Loader";
import utils from "../../../helpers/utils";
import { useTranslation } from 'react-i18next';


const CommonManagementActionPage = ({}) => {
    const { t } = useTranslation();

    let {id} = useParams();
    let {actionId} = useParams();
    let {actionType} = useParams();
    let {actionSubtype} = useParams();
    const history = useHistory();
    const models = useModels();

    const [loader, setLoader] = useState(false);
    const [format, setFormat] = useState();
    const [checked, setChecked] = useState([]);
    const [rightChecked, setRightChecked] = useState([]);
    const [reload, setReload] = useState(false);
    const [currentConfig, setCurrentConfig] = useState();

    const [actionDetails, setActionDetails] = useState();
    const [twin, setTwin] = useState(false);
    const [cleaningValidDuration, setCleaningValidDuration] = useState();


    const specialConfig = {
        list: {
            withComment: true,
            commentModel: models["part-replacement"],
            extended: true,
            button: t("common.exchange"),
            customSave: function (dto, onSaved) {
                Actions.post(`/format/${id}/replacePart`,
                    {
                        existingParts: dto.parts.map(c => c.id),
                        comment: dto.comment
                    },
                    onSaved)
            }
        },
        "part-replacement": {
            withComment: true,
            twinForReadonly: true,
            redirectModel: models.list,
            twinLeftTitle: t("status.exchanged"),
            twinRightTitle: t("status.added"),
            twinLeftFilter: function (part, details) {
                return details.existingParts?.some(ep => ep.id === part.id)
            },
            twinRightFilter: function (part, details) {
                return details.newParts?.some(ep => ep.id === part.id)
            }
        },
        //used twin because here is specific parts list name
        "part-withdrawal": {
            withComment: true,
            twinForReadonly: true,
            redirectModel: models.list,
            twinLeftTitle: t("status.withdrawn"),
            twinLeftFilter: function (part, details) {
                return details.existingParts?.some(ep => ep.id === part.id)
            },
            onlyLeft: true
        },
        service: {
            twin: true,
            twinLeftButton: t("status.to_service"),
            twinRightButton: t("status.to_warehouse"),
            twinLeftAction: "start",
            twinRightAction: "end",
            twinLeftTitle: t("status.to_service"),
            twinRightTitle: t("status.in_service"),
            twinFilter: function (part) {
                return part.status === "SERVICE" || part.partStatus === "SERVICE"
            }
        },
        cleaning: {
            withComment: true,
            cleaning: true,
            withDate: true,

        },
        dimensioning: {
            twin: true,
            twinLeftButton: t("status.to_dimensioning"),
            twinRightButton: t("status.to_warehouse"),
            twinLeftAction: "start",
            twinRightAction: "end",
            twinLeftTitle: t("status.to_dimensioning"),
            twinRightTitle: t("status.issued_to_dimensioning"),
            twinFilter: function (part) {
                return part.status === "DIMENSIONING" || part.partStatus === "DIMENSIONING"
            }
        }
    }

    function loadData() {
        setLoader(true);
        utils.loadCleaningValidDuration(setCleaningValidDuration)

        setCurrentConfig(specialConfig[actionType])
        setTwin(actionId ? specialConfig[actionType]?.twinForReadonly : specialConfig[actionType]?.twin)
        Actions.get("format/" + id, dataLoaded);
        if (actionId) {
            Actions.get(`management/${models[actionType].url}/${actionId}${actionSubtype ? '/' : ``}${actionSubtype ? actionSubtype : ``}`, setActionDetails);
        }
    }


    function dataLoaded(data) {
        setFormat(data);
        setLoader(false);
    }


    function inService(part) {
        return part.status === "SERVICE";
    }

    function defineMainFilter(actionDetails, currentConfig) {
        return (row) => {
            if (twin) {
                if (currentConfig?.twinLeftFilter) {
                    console.log("twinLeftFilter")
                    return currentConfig?.twinLeftFilter(row, actionDetails);
                }
                return !currentConfig?.twinFilter(row, actionDetails);
            }
            return actionDetails ? actionDetails.parts.some(p => p.id === row.id) : true;
        }
    }


    function defineRightFilter(actionDetails, currentConfig) {
        return (row) => {
            if (currentConfig?.twinRightFilter) {
                console.log("twinRightFilter")
                return currentConfig?.twinRightFilter(row, actionDetails);
            }
            return currentConfig?.twinFilter(row);

        }
    }

    useEffect(loadData, [reload, actionType]);


    function defineModel(actionType, actionSubtype) {
        if (actionSubtype) {
            const typeName = models[actionType].child.find(c => models[c].actionSubtype === actionSubtype)
            return models[typeName]
        }

        return models[actionType];
    }

    return (<>
        <Loader loader={loader}/>
        {
            <CustomContainer title={defineModel(actionType, actionSubtype).title}
                             parent={
                                 <>
                                     <LinkIconButton
                                         model={models.format}
                                     />
                                     <LinkIconButton
                                         model={models.management}
                                         link={models.management.url + "/" + id}
                                     />
                                     <LinkIconButton
                                         model={defineModel(actionType, actionSubtype)}
                                         link={models.management.url + "/" + id + "/" + (currentConfig?.redirectModel || models[actionType]).url}
                                     />
                                 </>
                             }
                             subtitle={
                                 <FormatHeader format={format}
                                               showDetails={true}
                                               disableDataAndUser={true}
                                               formatId={format?.id}/>
                             }
                             enableReady={true}
                             ready={format && (actionId ? actionDetails : true)}
            >

                <CommonManagementTable
                    actionId={actionId}
                    actionType={actionType}
                    cleaningValidDuration={cleaningValidDuration}
                    model={defineModel(actionType, actionSubtype)}
                    twinActionType={twin && currentConfig?.twinLeftAction}
                    width={twin ? 6 : 12}
                    readOnly={currentConfig?.readOnly}
                    extended={currentConfig?.extended}
                    actionDetails={actionDetails}
                    format={format}
                    setLoader={setLoader}
                    formatId={id}
                    setReload={setReload}
                    twin={twin}
                    cleaning={currentConfig?.cleaning}
                    commentAsColumn={currentConfig?.commentAsColumn}
                    commentModel={currentConfig?.commentModel}
                    withComment={currentConfig?.withComment}
                    withDate={currentConfig?.withDate}
                    title={twin ? currentConfig?.twinLeftTitle : undefined}
                    reload={reload}
                    customSave={currentConfig?.customSave}
                    saveTitle={twin ? currentConfig.twinLeftButton : currentConfig?.button || t("status.start")}
                    filter={defineMainFilter(actionDetails, currentConfig)}
                />
                {twin && !currentConfig?.onlyLeft &&
                    <CommonManagementTable
                        actionId={actionId}
                        actionType={actionType}
                        cleaningValidDuration={cleaningValidDuration}
                        model={defineModel(actionType, actionSubtype)}
                        twinActionType={twin && currentConfig?.twinRightAction}
                        right={true}
                        setReload={setReload}
                        title={twin ? currentConfig?.twinRightTitle : undefined}
                        width={6}
                        readOnly={currentConfig?.readOnly}
                        extended={currentConfig?.extended}
                        commentModel={currentConfig?.commentModel}
                        actionDetails={actionDetails}
                        cleaning={currentConfig?.cleaning}
                        format={format}
                        setLoader={setLoader}
                        formatId={id}
                        twin={true}
                        noDisableRule={true}
                        saveTitle={twin ? currentConfig.twinRightButton : t("status.start")}
                        reload={reload}
                        filter={defineRightFilter(actionDetails, currentConfig)}

                    />
                }

            </CustomContainer>
        }


    </>);
};


export default CommonManagementActionPage;